"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useScreenDimensions = function () {
    var _a = (0, react_1.useState)({
        width: window.innerWidth,
        height: window.innerHeight,
    }), dimensions = _a[0], setDimensions = _a[1];
    (0, react_1.useEffect)(function () {
        var handleResize = function () {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight - 0,
            });
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return dimensions;
};
exports.default = useScreenDimensions;
